import { takeEvery, put } from 'redux-saga/effects'

import { Files } from 'WebAPI'

import { actions } from '../constants'
import { fetchFileSuccess, fetchFileFailure } from '../reducers/actions'

const cache = new Map()

export function* fetchFile({ payload, meta }) {
  try {
    let src
    if (!cache.has(payload.ID)) {
      src = yield Files.details({
        FileID: payload.ID,
        HashSum_FileID_: payload.hash,
      })

      cache.set(payload.ID, src)
    } else {
      src = cache.get(payload.ID)
    }

    yield put(fetchFileSuccess(src.url, src.contentType))
  } catch (error) {
    yield put(fetchFileFailure(error.Error))
  }

  if (typeof meta.callback === 'function') {
    meta.callback()
  }
}

export default function* () {
  yield takeEvery(actions.FETCH_FILE, fetchFile)
}
